export const ClientMapStatus = {
  REVIEW: 'review',
  ACTIVE: 'active',
  DROP_OUT: 'drop_out',
  COMPLETE: 'complete',
  PRE_COMPLETE: 'pre_complete',
};
